<template>
  <div>
    <vessel-machine-table :id="id"></vessel-machine-table>
  </div>
</template>

<script>
import VesselMachineTable from '../components/tables/VesselMachineTable.vue'

export default {
  name: 'VesselMachines',
  components: {
    VesselMachineTable
  },
  props: {
    id: String
  }
}
</script>

<style scoped></style>
